import style from "./Middle.module.css"
import arrow_bottom from "../../assets/images/arrow_bottom.png"
import kefutime from "../../assets/images/kefutime.png"
export default function Main() {

  return (
    <>
      <div className={style.middleBox}>
        <div className={style.leftBox}>
          <h2>服务时间</h2>
          <img src={arrow_bottom} className={style.arrow} />
          {/* <img src={kefutime} style={{ width: "400px" }} /> */}
          <div className={style.kefutimebox}>
            <span>周一</span>
            <label></label>
            <span style={{ marginRight: "50px" }}>周五</span>
            <span>9:00</span>
            <label></label>
            <span>17:00</span>
          </div>
          <p className={style.gold}>我们用心聆听您的问题</p>
          <p>公司总机：0577-88927182 <span style={{ display: "inline-block", width: "20px" }}></span> 0577-89862222</p>
        </div>
      </div>

    </>
  )
}